import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This component runs when the browser returns from Emergent Google Auth with
// `#session_id=...` in the URL hash. It exchanges that session_id for a
// server-set httpOnly cookie and then navigates to the dashboard.
export default function AuthCallback() {
  const nav = useNavigate();
  const { refreshMe } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    if (!sessionId) {
      setError("Missing session id. Please try again.");
      setTimeout(() => nav("/login", { replace: true }), 1500);
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        // Clear the hash so refreshes don't re-trigger
        window.history.replaceState(null, "", "/app");
        await refreshMe();
        nav("/app", { replace: true });
      } catch (e) {
        setError(formatApiErrorDetail(e.response?.data?.detail) || e.message || "Google login failed");
        setTimeout(() => nav("/login", { replace: true }), 2000);
      }
    })();
  }, [nav, refreshMe]);

  return (
    <div className="min-h-screen flex items-center justify-center vp-hero-bg">
      <div className="vp-glass p-8 text-center" data-testid="auth-callback">
        <div className="font-display text-lg">
          {error ? (
            <span className="text-[#B00020]" data-testid="auth-callback-error">{error}</span>
          ) : (
            <>Signing you in…</>
          )}
        </div>
      </div>
    </div>
  );
}
